export default __webpack_public_path__ + "static/pressbutton-1.0.0.png";